/**
 * Общие детали рисунков для развёртки: толщины линий, ножки, ряды фасадов с ручками.
 *
 * Рисунки разделов (мебель, сантехника, декор) собираются из этих деталей, чтобы на одном
 * листе развёртки линии и ручки у всех предметов были одинаковыми. Размеры — в единицах
 * viewBox рисунка, то есть в миллиметрах типового предмета.
 */

/** Контур предмета */
export const line = { fill: "none", stroke: "currentColor", strokeWidth: 12 } as const;
/** Детали внутри контура: фасады, подушки, полки */
export const thin = { fill: "none", stroke: "currentColor", strokeWidth: 7 } as const;
/** Ручка фасада — короткий жирный штрих */
export const handle = { stroke: "currentColor", strokeWidth: 14, strokeLinecap: "round" } as const;

/** Две ножки у краёв предмета: от `top` до пола `floor` */
export const Legs = ({
	left,
	right,
	top,
	floor,
	width = 70,
}: {
	left: number;
	right: number;
	top: number;
	floor: number;
	width?: number;
}) => (
	<>
		<rect x={left} y={top} width={width} height={floor - top} {...thin} />
		<rect x={right - width} y={top} width={width} height={floor - top} {...thin} />
	</>
);

/** Ряд одинаковых фасадов с ручками: двери (ручки у стыков) или ящики (ручка по центру) */
export const Fronts = ({
	x,
	y,
	width,
	height,
	count,
	rows = 1,
	drawers = false,
}: {
	x: number;
	y: number;
	width: number;
	height: number;
	count: number;
	rows?: number;
	drawers?: boolean;
}) => {
	const w = width / count;
	const h = height / rows;
	return (
		<>
			{Array.from({ length: count * rows }, (_, i) => {
				const col = i % count;
				const row = Math.floor(i / count);
				const fx = x + col * w;
				const fy = y + row * h;
				// Дверь открывается от стыка: ручка у соседней двери, у одиночной — справа
				const hx = drawers
					? fx + w / 2
					: count === 1
						? fx + w - 50
						: col % 2 === 0
							? fx + w - 50
							: fx + 50;
				return (
					<g key={i}>
						<rect x={fx + 6} y={fy + 6} width={w - 12} height={h - 12} {...thin} />
						{drawers ? (
							<path
								d={`M${hx - Math.min(90, w / 5)} ${fy + h / 2}H${hx + Math.min(90, w / 5)}`}
								{...handle}
							/>
						) : (
							<path
								d={`M${hx} ${fy + h / 2 - Math.min(90, h / 6)}V${fy + h / 2 + Math.min(90, h / 6)}`}
								{...handle}
							/>
						)}
					</g>
				);
			})}
		</>
	);
};
